import {HttpRequest} from '../Data/HttpRequest'
import {server} from '../Data/BuildEnvironment'

export function createForInquiry(
    manufacturerId: number,
    inquiryNumber: number,
    comment: string
): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/manufacturers/${manufacturerId}/inquiries/${inquiryNumber}/comment`,
        headers: {
            Accept: 'application/json',
        },
        body: JSON.stringify({
            comment
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/InquiryCommentResource.ts